import { Component, Input } from '@angular/core';
import { AssignmentCustomerResponse, BaseAvatarSize, CustomerAssignmentListItemResponse } from 'base';

@Component({
  selector: 'base-customer-employee-short-info',
  templateUrl: './base-customer-external-employee-short-info.component.html',
})
export class BaseCustomerExternalEmployeeShortInfoComponent {
  @Input() currentAssignment: AssignmentCustomerResponse | CustomerAssignmentListItemResponse;
  @Input() avgRating?: number;
  @Input() ratingAmount?: number;
  avatarSize = BaseAvatarSize;
}
